const config = {
  mbgltk:
    "pk.eyJ1IjoiZGNhaXJucyIsImEiOiJjanc4ZHV0ZXAxbHY1NGJtcnQ2Z2Y3eTBzIn0.fWVb0SO_YJz9MFgLDkq5uw"
};

export default config;
